import Konva from 'konva'
import StageData from '@ps/store/workbench/stage/stage-data'
import { getNodeByShape } from '@ps/store/workbench/stage/utils/helper'
import { isRestrictedNode } from '@ps/bridge/qc/base'

const MIN_RECT_WIDTH = 1
const MIN_RECT_HEIGHT = 1
/**
 * 节点选中框默认样式
 */
export const transformerConfig: Konva.TransformerConfig = {
  borderStrokeWidth: 2,
  borderStroke: 'rgba(0,0,0,0.1)',
  anchorFill: '#fff',
  anchorSize: 30,
  anchorStroke: 'rgba(0,0,0,0.1)',
  anchorStrokeWidth: 10,
  rotateAnchorOffset: 20,
  keepRatio: false,
  centeredScaling: false,
  flipEnabled: false,
  useSingleNodeRotation: true,
  rotationSnaps: [0, 45, 90, 135, 180, 225, 270, 315],
  enabledAnchors: ['top-left', 'top-right', 'bottom-left', 'bottom-right'],
  rotationSnapTolerance: 5,
  shouldOverdrawWholeArea: false,
  boundBoxFunc: function (oldBox, newBox) {
    const selectedShape = StageData.transformer!.nodes()[0] as Konva.Rect
    const node = getNodeByShape(selectedShape)
    // 如果选择的是画线区域，则限制其缩放的最大宽高
    if (isRestrictedNode(node)) {
      const parentShape = StageData.layer!.findOne(`#${node.parent.uuid}`)
      const parentRect = parentShape.getClientRect()
      // 正向缩放最大的宽度与高度
      const forwardMaxWidth =
        parentRect.width + parentRect.x - Math.max(newBox.x, parentRect.x)
      const forwardMaxHeight =
        parentRect.height + parentRect.y - Math.max(newBox.y, parentRect.y)
      // 反向缩放最大的宽度与高度
      const negativeMaxWidth =
        newBox.width + newBox.x - Math.max(newBox.x, parentRect.x)
      const negativeMaxHeight =
        newBox.height + newBox.y - Math.max(newBox.y, parentRect.y)
      return {
        ...newBox,
        x: Math.max(newBox.x, parentRect.x),
        y: Math.max(newBox.y, parentRect.y),
        width: Math.max(
          Math.min(newBox.width, forwardMaxWidth, negativeMaxWidth),
          MIN_RECT_WIDTH,
        ),
        height: Math.max(
          Math.min(newBox.height, forwardMaxHeight, negativeMaxHeight),
          MIN_RECT_HEIGHT,
        ),
      }
    }
    // width and height of the boxes are corresponding to total absolute width and height of all nodes combined
    if (newBox.width < MIN_RECT_WIDTH || newBox.height < MIN_RECT_HEIGHT) {
      return oldBox
    }
    return newBox
  },
}
